import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';
import _ from 'lodash-es';

import callApi from '../apiService';
import objectFactory from '../objectFactory';

const initialState = {
  providers: [],
  wizardDbObjectShell: {
    controlling_instance: null,
    target_bendable_instance: null,
    table_name: 'providers',
    status: 'draft',
    raw_data: {}
  },
  status: 'idle',
};

const fetchDbObjectShells = async (options) => {
  console.log('providersSlice.fetchDbObjectShells() options: ', options);
  options.limit = options.limit || 'all';

  try {
    const response = await callApi('getDbObjectShells', null, { params: options });
    console.log('providersSlice.fetchDbObjectShells() response: ', response);
    return response.data;   // axios attribute
  } catch (error) {
    console.error('providersSlice.fetchDbObjectShells() error: ', error.message);
  }
};

export const getDbObjectShells = createAsyncThunk(
  'providers/getDbObjectShells',
  async (options) => {
    const response = await fetchDbObjectShells(options);
    return { tableName: options.tableName, rows: response.payload };
  }
);

const fetchProviders = async (options) => {
  console.log('providersSlice.fetchProviders() options: ', options);
  options.limit = options.limit || 'all';

  try {
    const response = await callApi('getProviders', { apiVersion: options?.apiVersion }, { params: options });
    console.log('providersSlice.fetchProviders() response: ', response);
    return response.data;   // axios attribute
  } catch (error) {
    console.error('providersSlice.fetchProviders() error: ', error.message);
  }
};

export const getProviders = createAsyncThunk(
  'providers/getProviders',
  async (options) => {
    console.log('providersSlice.getProviders() options: ', options);
    const response = await fetchProviders(options);
    console.log('providersSlice.getProviders() response: ', response);
    return { providers: response.payload.providers };
  }
);

export const buildWizardDbObjectShell = createAsyncThunk(
  'providers/buildWizardDbObjectShell',
  async (options) => {
    console.log('providersSlice buildWizardDbObjectShell() options: ', options);
    const response = await fetchProviders(options);
    console.log('providersSlice.buildWizardDbObjectShell() response: ', response);
    return { provider: (response.payload?.providers && response.payload.providers[0]) || null };
  }
);



export const providersSlice = createSlice({
  name: 'providers',
  initialState,
  reducers: {
    mergeProviderWizardRootData: (state, action) => {
      console.log('providersSlice mergeProviderWizardRootData before merge; state, action: ', current(state), action);
      // the .mergeWith() below can generate this error: Unhandled Rejection (Error): [Immer] Immer only supports setting array indices and the 'length' property
      // so let's avoid Immer with cloneDeep...
      // state.wizardDbObjectShell = _.mergeWith(state.wizardDbObjectShell, action.payload, (objValue, srcValue, key, object, source, stack) => {
      const stateCopy = _.cloneDeep(state.wizardDbObjectShell);
      const payloadCopy = _.cloneDeep(action.payload);
      state.wizardDbObjectShell = _.mergeWith(stateCopy, payloadCopy, (objValue, srcValue, key, object, source, stack) => {
        if (_.isArray(srcValue)) {
          return srcValue;              // allows empty arrays to overwrite existing arrays
        } else {
          return undefined;
        }
      });
      console.log('providersSlice mergeProviderWizardRootData after merge; state: ', current(state));
    },
    mergeProviderWizardRawData: (state, action) => {
      console.log('providersSlice mergeProviderWizardRawData before merge; state, action: ', current(state), action);
      // the .mergeWith() below can generate this error: Unhandled Rejection (Error): [Immer] Immer only supports setting array indices and the 'length' property
      // so let's avoid Immer with cloneDeep...
      // state.wizardDbObjectShell.raw_data = _.mergeWith(state.wizardDbObjectShell.raw_data, action.payload, (objValue, srcValue, key, object, source, stack) => {
      const stateCopy = _.cloneDeep(state.wizardDbObjectShell.raw_data);
      console.log('providersSlice mergeProviderWizardRootData stateCopy: ', stateCopy);
      const payloadCopy = _.cloneDeep(action.payload);
      console.log('providersSlice mergeProviderWizardRootData payloadCopy: ', payloadCopy);
      state.wizardDbObjectShell.raw_data = _.mergeWith(stateCopy, payloadCopy, (objValue, srcValue, key, object, source, stack) => {
        // console.log('providersSlice mergeProviderWizardRawData objValue: ', objValue);
        // console.log('providersSlice mergeProviderWizardRawData srcValue: ', srcValue);
        // console.log('providersSlice mergeProviderWizardRawData key: ', key);
        // console.log('providersSlice mergeProviderWizardRawData object: ', object);
        // console.log('providersSlice mergeProviderWizardRawData source: ', source);
        if (_.isArray(srcValue)) {
          return srcValue;              // allows empty arrays to overwrite existing arrays
        } else {
          return undefined;
        }
      });

      console.log('providersSlice mergeProviderWizardRawData after merge; state: ', current(state));
    },
    resetProviderWizardData: (state, action) => {
      console.log('providersSlice resetWizardData; state, action: ', current(state), action);
      state.wizardDbObjectShell = {
        controlling_instance: null,
        target_bendable_instance: null,
        table_name: 'providers',
        status: 'draft',
        raw_data: {},
      };
    },
  },
  extraReducers: (builder) => {
    builder
  //   .addCase(getDbObjectShells.pending, (state) => {
  //     console.log('providersSlice getDbObjectShells.pending state: ', state);
  //     state.status = 'loading';
  //   })
  //   .addCase(getDbObjectShells.fulfilled, (state, action) => {
  //     state.status = 'idle';
  //     console.log('providersSlice getDbObjectShells.fulfilled action: ', action);
  //     state.currentDbObjectShells[action.payload.tableName] = action.payload.rows;
  //     // console.log('getDbObjectShells case; state: ', current(state));
  //   });
    .addCase(getProviders.pending, (state) => {
      console.log('providersSlice getProviders.pending state: ', state);
      state.status = 'loading';
    })
    .addCase(getProviders.fulfilled, (state, action) => {
      state.status = 'idle';
      console.log('providersSlice getProviders.fulfilled action: ', action);
      state.providers = action?.payload?.providers || [];
      // console.log('getProviders case; state: ', current(state));
    })
    .addCase(buildWizardDbObjectShell.pending, (state) => {
      console.log('providersSlice buildWizardDbObjectShell.pending state: ', state);
      state.status = 'loading';
    })
    .addCase(buildWizardDbObjectShell.fulfilled, (state, action) => {
      state.status = 'idle';
      console.log('providersSlice buildWizardDbObjectShell.fulfilled action: ', action);
      const provider = action?.payload?.provider;
      const targetBendableInstance = action?.meta?.arg?.target_bendable_instance || 'bendable-labs';
      const dbObjectShell = objectFactory.buildDbObjectShellFromProviderDocument(provider, targetBendableInstance);
      console.log('providersSlice buildWizardDbObjectShell.fulfilled dbObjectShell: ', dbObjectShell);
      state.wizardDbObjectShell = dbObjectShell;  
      // console.log('buildWizardDbObjectShell case; state: ', current(state));
    });
},
});

export const {
  resetProviderWizardData,
  mergeProviderWizardRootData,
  mergeProviderWizardRawData,
} = providersSlice.actions;

// for useSelector; state is complete store, not slice
export const selectCurrentWizardDbObjectShell = (state) => state.providers.wizardDbObjectShell;
export const selectProviders = (state) => state.providers.providers;

export default providersSlice.reducer;
